export const sourceDocumentDetailsState = {
  id: 0,
  ingestedId: 0,
  updateType: 0,
  notes: [],
  prodStatusID: 0,
};
